export default __webpack_public_path__ + "media/save-memories2x.8b48688b.png";